import {
  createListAllQuery,
  getUser,
  GetUserQuery,
  GetUserQueryVariables,
  graphqlCall,
  listUsers,
  ListUsersQuery,
  ListUsersQueryVariables,
  User,
  userByHabitat,
  UserByHabitatQueryVariables,
  userByUsername,
  UserByUsernameQuery,
  UserByUsernameQueryVariables,
} from '@akin-home/amplify';
import { createMockableFunction } from '@akin-home/testing';
import { findDefaultUser } from '@akin-home/user';
import {
  getMockUser,
  getMockUserByUsername,
  listMockUsersAsync,
} from '../mocks';

export const listUsersQuery = (params?: ListUsersQueryVariables) =>
  graphqlCall<ListUsersQuery>(listUsers, params);

const _listAllUsersQuery = createListAllQuery<User, ListUsersQueryVariables>(
  listUsers,
  'listUsers'
);

const _listAllUsersByHabitatQuery = createListAllQuery<
  User,
  UserByHabitatQueryVariables
>(userByHabitat, 'userByHabitat');

const _listAllUsersByUsernameQuery = createListAllQuery<
  User,
  UserByUsernameQueryVariables
>(userByUsername, 'userByUsername');

const _getUserQuery = (params: GetUserQueryVariables) =>
  graphqlCall<GetUserQuery>(getUser, params);

const _getUserByUsernameQuery = (params?: UserByUsernameQueryVariables) =>
  graphqlCall<UserByUsernameQuery>(userByUsername, params);

export const listAllUsersQuery = createMockableFunction<
  [ListUsersQueryVariables | undefined]
>({
  main: _listAllUsersQuery,
  mock: listMockUsersAsync,
});

export const listAllUsersByHabitatQuery = createMockableFunction<
  [UserByHabitatQueryVariables]
>({
  main: _listAllUsersByHabitatQuery,
  mock: listMockUsersAsync,
});

export const listAllUsersByUsernameQuery = createMockableFunction<
  [UserByUsernameQueryVariables]
>({
  main: _listAllUsersByUsernameQuery,
  mock: listMockUsersAsync,
});

export const getDefaultUserByUsername = async (username: string) => {
  const result: User[] = await listAllUsersByUsernameQuery({ username });

  if (!result.length) {
    return;
  }

  return findDefaultUser(result as any);
};

export const getUserQuery = createMockableFunction({
  main: _getUserQuery,
  mock: async ({ id }) => ({ data: { getUser: getMockUser(id) as any } }),
});

export const getUserByUsernameQuery = createMockableFunction({
  main: _getUserByUsernameQuery,
  mock: async (params) => ({
    data: {
      userByUsername: getMockUserByUsername(
        params?.username || undefined
      ) as any,
    },
  }),
});
